exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.finance-calculator__card-item--ev-grant {\n    background: #e6f4ff; /* light blue */\n    border: 1px solid #c2e4ff;\n    border-radius: 4px;\n    padding: 0.75rem 1rem;\n    margin-bottom: 0.75rem;\n}\n.finance-calculator__card-item-label--full {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    font-weight: 600;\n    color: #004b73; /* darker complementary blue */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7bd9140","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/new-vue/components/details/FinanceCalculator.vue
// module id = U4LO
// module chunks = 17